import type { Action, ScheduleActionDisplayOptions } from "@core/features/actions";
import { SchedulingContainer } from "@platform/features/programScheduling";

export type Props = {
  /** Program ID */
  programId: number;
  /** The schedule action */
  action: Action | undefined;
  /** Display options from the action */
  displayOptions: ScheduleActionDisplayOptions | null;
  /** Handler for next button */
  onNext: () => void;
  /** Handler for back button (hidden if undefined) */
  onBack?: () => void;
  /** Handler for skip button (hidden if undefined) */
  onSkip?: () => void;
  /** Current step index (0-indexed) - passed for consistency but not used */
  stepIndex: number;
  /** Total steps - passed for consistency but not used */
  totalSteps: number;
};

/**
 * Weekly availability selection sub-step for schedule onboarding.
 * Uses the existing SchedulingContainer component which has its own action bar.
 * Note: stepIndex/totalSteps are received for interface consistency but not displayed
 * because SchedulingContainer manages its own UI with StickyActionBar.
 */
export function AvailabilitySubStep({
  programId,
  displayOptions,
  onNext,
  onSkip,
}: Props) {
  return (
    <SchedulingContainer
      programId={programId}
      scheduledEngagementStartDate={displayOptions?.scheduled_engagement_start_date}
      mode={displayOptions?.mode}
      selectableOptions={displayOptions?.selectableOptions}
      requiredSelections={displayOptions?.requiredSelections}
      maxSelections={displayOptions?.maxSelections}
      headerFormat={displayOptions?.headerFormat}
      onSuccess={onNext}
      onSkip={onSkip}
      variant="inline"
      primaryButtonText="Continue"
    />
  );
}

export default AvailabilitySubStep;
